import { Loader } from 'semantic-ui-react';
import styled from 'styled-components';

const StyledLoader = styled(Loader)``;

export default StyledLoader;
